import { useTranslation } from "react-i18next";
import image1 from "../../common/images/1.jpg";
import image2 from "../../common/images/2.jpg";
import image3 from "../../common/images/3.jpg";
import image4 from "../../common/images/4.jpg";
import image5 from "../../common/images/5.jpg";
import image6 from "../../common/images/6.jpg";

const Gallery = () => {
  const { t } = useTranslation(["common"]);
  return (
    <section
      id="gallery"
      className="flex justify-center  items-center  min-h-screen container px-3 m-auto text-gray-600 py-10"
    >
      <div>
        <div role="main" className="flex flex-col items-center justify-center">
          <h1 className="text-4xl font-semibold leading-9 text-center text-gray-800">
            {t("common:gallery")}
          </h1>
          <p className="text-base leading-normal text-center text-gray-600 mt-4 lg:w-1/2 md:w-10/12 w-11/12">
            {t("common:products_text")}
          </p>
        </div>
        <div className="lg:flex items-stretch md:mt-12 mt-8">
          <div className="lg:w-1/2">
            <div className="sm:flex items-center justify-between xl:gap-x-8 gap-x-6">
              <div className="sm:w-1/2 relative overflow-hidden group">
                <h2 className="absolute -bottom-10 group-hover:bottom-2 duration-500 shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                  {t("product_orange")}
                </h2>
                <img src={image1} className="w-full rounded-lg" alt="chair" />
              </div>
              <div className="sm:w-1/2 sm:mt-0 mt-4 relative overflow-hidden group">
                <h2 className="absolute -bottom-10 group-hover:bottom-2 duration-500 shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                  {t("product_apple")}
                </h2>
                <img
                  src={image2}
                  className="w-full rounded-lg"
                  alt="wall design"
                />
              </div>
            </div>
            <div className="relative overflow-hidden group">
              <h2 className="absolute -bottom-10 group-hover:bottom-2 duration-500 shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                {t("product_pomergranate")}
              </h2>
              <img
                src={image3}
                alt="sitting place"
                className="rounded-lg w-full mt-8 md:mt-6 hidden sm:block"
              />
              <img
                className="rounded-lg w-full mt-4 sm:hidden"
                src={image3}
                alt="sitting place"
              />
            </div>
          </div>
          <div className="lg:w-1/2 xl:ml-8 lg:ml-4 lg:mt-0 md:mt-6 mt-4 lg:flex flex-col justify-between">
            <div className="relative overflow-hidden group">
              <h2 className="absolute -bottom-10 group-hover:bottom-2 duration-500 shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                {t("product_orange")}
              </h2>
              <img
                src={image4}
                alt="sitting place"
                className="w-full rounded-lg sm:block hidden"
              />
              <img
                className="w-full rounded-lg sm:hidden"
                src={image4}
                alt="sitting place"
              />
            </div>
            <div className="sm:flex items-center justify-between xl:gap-x-8 gap-x-6 md:mt-6 mt-4">
              <div className="relative overflow-hidden group w-full">
                <h2 className="absolute  -bottom-10 group-hover:bottom-2 duration-500  shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                  {t("product_apple_and_carrot")}
                </h2>
                <img src={image5} className="w-full rounded-lg" alt="chair" />
              </div>
              <div className="relative w-full overflow-hidden group sm:mt-0 mt-4">
                <h2 className="absolute -bottom-10 group-hover:bottom-2 duration-500 shadow-xl left-2/4 -translate-x-2/4 text-xl font-semibold backdrop-blur whitespace-nowrap px-2 rounded-md text-white">
                  {t("product_grape")}
                </h2>
                <img
                  src={image6}
                  className="w-full rounded-lg"
                  alt="wall design"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
